import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Origin"
});
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createStaticVNode('<path d="M8.60467 8.34145C8.84575 8.47283 8.99577 8.72544 8.99577 9V15.75H7.49577V10.3762L6.02201 11.3267L5.20898 10.0662L7.83926 8.36972C8.06999 8.22091 8.36359 8.21006 8.60467 8.34145Z"></path><path d="M18.0258 9C18.0258 8.72544 17.8758 8.47283 17.6347 8.34145C17.3936 8.21006 17.1 8.22091 16.8693 8.36972L14.239 10.0662L15.052 11.3267L16.5258 10.3762V15.75H18.0258V9Z"></path><path d="M12.75 9.24902V11.249H11.25V9.24902H12.75Z"></path><path d="M12.75 14.75V12.75H11.25V14.75H12.75Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21 3H3C2.17157 3 1.5 3.67157 1.5 4.5V19.5C1.5 20.3284 2.17157 21 3 21H21C21.8284 21 22.5 20.3284 22.5 19.5V4.5C22.5 3.67157 21.8284 3 21 3ZM21 19.5H3.00586V4.5H21V19.5Z"></path>', 5);
const _hoisted_7 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Origin.vue"]]);
